import rudderAnalytics from "../../../utilities/rudderanalytics";

export function initReferralProgram() {
  const email_input = document.getElementById("referral-email-input");
  const invite_button = document.getElementById("invite-button");

  const request_response_success = document.querySelector(
    ".request-response.referral-success"
  );
  const request_response_error = document.querySelector(
    ".request-response.referral-error"
  );
  const error_text = document.querySelector(".referral-error-text");

  const share_link_btn = document.querySelector(".share-link-btn");
  const share_link_text = document.querySelector(".share-link-text");

  const no_invitations_container = document.querySelector(".no-invitations");

  email_input?.addEventListener("input", () => {
    request_response_success.style.display = "none";
    request_response_error.style.display = "none";

    if (email_input.value) {
      invite_button.classList.add("entered-email");
    } else {
      invite_button.classList.remove("entered-email");
    }
  });

  const referral_program_nav_item = document.querySelector(
    ".referral-program-nav-item"
  );
  referral_program_nav_item?.addEventListener("click", function () {
    rudderAnalytics.track("web_referral_program_nav_clicked");
  });

  const invitations_list = document.getElementById("invitations-list");

  function isValidEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  }

  function addEmailToList(email) {
    if (no_invitations_container) {
      no_invitations_container.style.display = "none";
    }
    const emailDiv = document.createElement("disv");
    emailDiv.className = "d-flex justify-content-between referred-email-line";
    emailDiv.innerHTML = `
         <div>
            <div class="t-200 t-200-strong mb-1 mobile-text mobile-text-bold email-address">${email}</div>
         </div>
         <div class="t-200 mobile-text"> Invitation Sent </div>
      `;
    invitations_list.appendChild(emailDiv);
  }

  function createReferral(referred_email, referring_user_id) {
    $.ajax({
      url: "/api/v1/accounts/create_referral",
      type: "POST",
      data: {
        referred_email: referred_email,
        referring_user_id: referring_user_id,
      },
      success: function (response) {
        if (response.success) {
          request_response_success.style.display = "block";
          addEmailToList(referred_email);
          rudderAnalytics.track("web_referral_invitation_success");
        } else {
          console.log(response.error);
          error_text.textContent = response.error;
          request_response_error.style.display = "flex";
          rudderAnalytics.track("web_referral_invitation_warning");
        }
        invite_button.innerHTML = "Invite via email";
      },
      error: function (xhr, status, error) {
        alert("An error occurred: " + error);
        invite_button.innerHTML = "Invite via email";
      },
    });
  }

  invite_button?.addEventListener("click", function () {
    const referring_user_id = document.querySelector(".referral-program")
      .dataset.id;
    const referred_email = email_input.value.trim();
    if (isValidEmail(referred_email)) {
      this.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';
      createReferral(referred_email, referring_user_id);
      email_input.value = "";
    } else {
      alert("Please enter a valid email address.");
    }
  });

  share_link_btn?.addEventListener("click", function () {
    const referring_user_hash = document.querySelector(".referral-program")
      .dataset.hash;
    const share_link =
      "https://theguestbook.com/users/sign_up?referral=" + referring_user_hash;

    rudderAnalytics.track("web_referral_copy_share_link_clicked");

    navigator.clipboard
      .writeText(share_link)
      .then(() => {
        share_link_text.textContent = "Copied!";
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  });
}
